import React from 'react';
import _ from 'lodash';
import toTsvString from '../../utils/toTsvString';
import DownloadContainer from 'containers/DownloadContainer';

let groupByType = (xs: Array<Object>, type: string) => (
  (xs || []).reduce((acc, val) => ({
    ...acc,
    [val[type]]: [ ...(acc[val[type]] || []), val ]
  }), {})
);

let flattenedAfterGrouping = (x: Object): Array<Object> => {
  return Object.keys(x || {}).reduce((acc, key) => [
    ...acc,
    ...x[key],
  ], []);
};

let projectRelatedCase = (xs: Array<Object>) => {
  return (xs || []).map(x => ({
    ...x,
    related_case: ((x.related_cases || [])[0] || {}).submitter_id
  }));
};

let projectValidEntity = (xs: Array<Object>) => {
  return (xs || []).map(x => ({
    id: x.id,
    related_case: x.related_case,
    type: x.type,
    action: x.action,
    submitter_id: ((JSON.parse(x.unique_keys) || [])[0] || {}).submitter_id
  }));
};

let validTsvString =
  _.compose(toTsvString, projectValidEntity, projectRelatedCase, flattenedAfterGrouping);

export default ({ entities, filename, style, children, customDataTestID }) => {
  let groupedByType = entities &&
    (entities.length
       ? groupByType(entities, `type`)
       : {});

  return (
      <DownloadContainer
        customDataTestID={customDataTestID}
        body={ entities.length ? validTsvString(groupedByType) : `` }
        format="TSV"
        filename={filename}
        style={style}
      >
        { children }
      </DownloadContainer>
  );
};
